module.exports = __webpack_public_path__ + "static/media/logo.9dacff94.svg";